var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.00011L17.0428 3.00193L17.1281 3.01672L17.191 3.0379L17.267 3.07729L17.3221 3.1177L17.3824 3.17798L17.4112 3.21545L17.4533 3.28871L17.4834 3.37197L17.4979 3.45432L17.5 3.50011V9.50011C17.5 9.77625 17.2761 10.0001 17 10.0001C16.7545 10.0001 16.5504 9.82323 16.5081 9.58998L16.5 9.50011V4.70611L5.206 16.0001H10C10.2455 16.0001 10.4496 16.177 10.4919 16.4102L10.5 16.5001C10.5 16.7456 10.3231 16.9497 10.0899 16.9921L10 17.0001L3.97964 16.9997L3.9112 16.9922L3.80896 16.9623L3.73299 16.9229L3.67786 16.8825L3.61758 16.8222L3.58884 16.7848L3.54674 16.7115L3.51661 16.6282L3.51109 16.6051C3.50383 16.5714 3.5 16.5362 3.5 16.5001L3.50546 16.574L3.50182 16.5429L3.5 10.5001C3.5 10.224 3.72386 10.0001 4 10.0001C4.24546 10.0001 4.44961 10.177 4.49194 10.4102L4.5 10.5001V15.2921L15.792 4.00011H11C10.7545 4.00011 10.5504 3.82323 10.5081 3.58998L10.5 3.50011C10.5 3.22396 10.7239 3.00011 11 3.00011Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.fe61cf8db5b64a1321a2c11d5f90450e.svg";
export { ForwardRef as ReactComponent };